import request from '../../utils/request';
import {paramSecret} from "../../utils/commonSecret";


// 获取商品列表
export async function getCommodityList(params, isH5) {
    return request('/api/v1/front-common/commodity/list', {
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params, isH5)),
    })
}

// 创建订单
export async function rechargeCreate(params, isH5) {
    return request('/api/v1/business-server/api/rechargecreate', {
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params, isH5)),
    })
}

// 下单
export async function rechargePay(params, isH5) {
    return request('/api/v1/business-server/api/rechargepay', {
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params, isH5)),
    })
}

//查看订单详情
export async function getOrderInfo(params, isH5) {
    return request('/api/v1/business-server/api/getorderinfo', {
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params, isH5)),
    })
}

// 苹果包H5支付下单
export async function appleH5Pay(params, isH5) {
    return request('/api/v1/business-server/api/submitorderbyh5', {
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params, isH5)),
    })
}
